import { Component, computed, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FunctionALTreatmentPackages, ProfessionalTreatmentPackages } from "libs/treatments/src/lib/models";
import { ProfessionalPackagesService } from "libs/treatments/src/lib/services";
import { faCircleParking } from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FaIconComponent, FaLayersComponent } from "@fortawesome/angular-fontawesome";

@Component({
	selector: "lib-packages-preview",
	imports: [CommonModule, FaIconComponent, FaLayersComponent],
	templateUrl: "./packages-preview.component.html",
	styleUrl: "./packages-preview.component.scss",
})
export class PackagesPreviewComponent {
	readonly packages = input.required<ProfessionalTreatmentPackages | FunctionALTreatmentPackages | null>();
	readonly hasPreAlignerSalesOrder = input<boolean>(false);
	readonly maxShownPackages = 8;

	readonly professionalPackages = computed<ProfessionalTreatmentPackages | null>(() => {
		const packages = this.packages();
		return packages != null && "steps" in packages ? packages as ProfessionalTreatmentPackages : null;
	});
	readonly functionALPackages = computed<FunctionALTreatmentPackages | null>(() => {
		const packages = this.packages();
		return packages != null && !("steps" in packages) ? packages as FunctionALTreatmentPackages : null;
	});
	readonly totalProfessionalPackages = computed<number>(() => {
		const packages = this.professionalPackages();
		if (!packages) {
			return 0;
		}
		return ProfessionalPackagesService.getTotalPackageCount(packages);
	});

	faCircleParking = faCircleParking;
	faCircle = faCircle;
}
